import AccordionUtils from '../util/accordion-utils';

/**
 * This class controls the Multi Stats module.
 */
export default class StatsMulti {

    constructor(root) {
        this.container = root.querySelector('.container');
        this.tabs = Array.from(this.container.querySelectorAll('.tabs li'));
        this.pages = Array.from(this.container.querySelectorAll('.stats-container .page[data-page]'));

        AccordionUtils.initAccordions(this.container);

        this.registerListeners();
    }

    registerListeners() {
        const instance = this;

        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => instance.handleTabClicked(tab, instance));
        });
    }

    handleTabClicked(tab, instance) {
        tab.classList.add('selected');
        instance.tabs.forEach((node) => {
            if(!node.isEqualNode(tab)) {
                node.classList.remove('selected');
            }
        });

        const label = tab.innerText;
        instance.pages.forEach((page) => {
            if(page.dataset.page.toLowerCase() === label.toLowerCase()) {
                page.classList.add('selected');
            } else {
                page.classList.remove('selected');
            }
        });
    }
}